import { render, staticRenderFns } from "./AboutStatic.vue?vue&type=template&id=30bb04e7&scoped=true&"
import script from "./AboutStatic.vue?vue&type=script&lang=ts&"
export * from "./AboutStatic.vue?vue&type=script&lang=ts&"
import style0 from "./AboutStatic.vue?vue&type=style&index=0&id=30bb04e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bb04e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
